module.exports = __webpack_public_path__ + "img/duplicate.ab93f8d4.svg";